import ConstituentSearchColumn from '@/constants/ConstituentSearchColumn';
import type CustomField from '@/types/api/CustomField';
import type ConstituentColumnSelectFormValues from '../types/ConstituentColumnSelectFormValues';

const mapColumnsToDefaultValues = (
  queryColumns: ConstituentSearchColumn[],
  queryCustomFieldColumns: string[],
  customFieldData: CustomField[],
) => {
  const defaultValues: ConstituentColumnSelectFormValues = {};

  Object.values(ConstituentSearchColumn).forEach((column) => {
    if (column !== ConstituentSearchColumn.CONSTITUENT_RULES) {
      defaultValues[column] = queryColumns.includes(column);
    }
  });

  customFieldData.forEach(({ customFieldId }) => {
    defaultValues[customFieldId] =
      queryCustomFieldColumns.includes(customFieldId);
  });

  return defaultValues;
};

export default mapColumnsToDefaultValues;
